import { useState, useEffect } from 'react';

interface ScrollContext {
    element: HTMLElement | null;
    initialRect: DOMRect | null;
}

// Maintains the current element's relative screen position when replacing large parts of the DOM above.
function useMaintainScrollPosition() {
    const [scrollContext, setScrollContext] = useState<ScrollContext | null>(null);

    const prepareScrollContext = (element: HTMLElement) => {
        setScrollContext({
            element,
            initialRect: element.getBoundingClientRect(),
        });
    };

    useEffect(() => {
        if (scrollContext) {
            // Defer scroll adjustment to ensure it happens after DOM updates.
            requestAnimationFrame(() => {
                if (scrollContext.element) {
                    const newRect = scrollContext.element.getBoundingClientRect();
                    const newScrollY = window.scrollY;

                    const positionDifference = newRect.top - (scrollContext.initialRect ? scrollContext.initialRect.top : 0);
                    const adjustedScrollY = newScrollY + positionDifference;

                    window.scrollTo({ top: adjustedScrollY, behavior: 'auto' });
                }
            });
        }
    }, [scrollContext]);

    return prepareScrollContext;
}

export default useMaintainScrollPosition;
